import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './Components/ScrollToTop';
import Home from "./Pages/Home";
import About from "./Pages/About";
import GalleryPage from './Pages/Gallery';
import BlogDetail from './Pages/BlogDetails';
import BlogPage from './Pages/Blog';
import ContactPage from './Pages/Contact/ContactUs';
import Category from './Pages/Products/Category'; // Or whatever your file is named
import Products from './Pages/Products/Products'; // The one we are building now
import Book from './Pages/Bookings/Book';
import Interested from './Pages/Inquery/Inquery';
import NotFound from './Pages/404';
import AdminLayout from './Pages/Admin/Components/adminLayout';
import AdminLogin from './Pages/Admin/Login';
import Dashboard from './Pages/Admin/Dashboard';
import Bookings from './Pages/Admin/Bookings';
import ManageInquiries from './Pages/Admin/Message';
import ManageInterests from './Pages/Admin/Intrested'; 
import ManageCategory from './Pages/Admin/Category/Categories';
import UpdateCategory from './Pages/Admin/Category/Updatecategory';
import ManageProducts from './Pages/Admin/Products/Products';
import UpdateProduct from './Pages/Admin/Products/Updateproduct';
import ManageBlogs from './Pages/Admin/Blog/Blog';
import UpdateBlog from './Pages/Admin/Blog/Updateblog';
import ManageGallery from './Pages/Admin/Gallery/Gallery';
import Customers from './Pages/Admin/Customers';
import PrivacyPolicy from './Pages/Privacy';
import TermsAndConditions from './Pages/Terms';
import Settings from './Pages/Admin/Settings';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  return token ? children : <Navigate to="/admin-login" />;
};

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* <--- ADD THIS LINE HERE */}
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/category/:id" element={<Category />} />
          <Route path="/products" element={<Products />} />
          <Route path="/book" element={<Book />} />
          <Route path="/interested" element={<Interested />} />
          <Route path="/admin" element={<AdminLayout />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="*" element={<NotFound />}/>

                    {/* --- ADMIN ROUTES --- */}
          <Route path="/admin-login" element={<AdminLogin />} />
          
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute> 
            }
          >
            {/* These load inside the AdminLayout Outlet */}
            <Route index element={<Dashboard />} />
            <Route path='/admin/bookings' element={<Bookings />} /> 
            <Route path='/admin/inquiries' element={<ManageInquiries />} />
            <Route path='/admin/interests' element={<ManageInterests />} />
            <Route path='/admin/categories' element={<ManageCategory />} />
            <Route path='/admin/update-category/:id' element={<UpdateCategory />} />
            <Route path='/admin/products' element={<ManageProducts />} />
            <Route path='/admin/update-product/:id' element={<UpdateProduct />} />
            <Route path='/admin/blogs' element={<ManageBlogs />} />
            <Route path='/admin/update-blog/:id' element={<UpdateBlog />} />
            <Route path='/admin/gallery' element={<ManageGallery />} />
            <Route path='/admin/customers' element={<Customers />} />
            <Route path='/admin/settings' element={<Settings />} />
          </Route>

          {/* --- 404 ROUTE --- */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
